var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIkon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.678,
    height: 51.091,
    viewBox: "0 0 60.678 51.091",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cloud-ikon",
    transform: "translate(5114.803 -10293.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "security-1652491",
    transform: "translate(-5102.987 10318.439)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_459",
    "data-name": "Rectangle 459",
    width: 28.135,
    height: 19.086,
    transform: "translate(4.456 0)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8274",
    "data-name": "Path 8274",
    d: "M54.947,346.087H17.9l4.456-6.387H50.491Z",
    transform: "translate(-17.9 -320.591)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8276",
    "data-name": "Path 8276",
    d: "M232.2,184.9l1.977,1.977,5.78-5.78",
    transform: "translate(-217.441 -174.447)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_108",
    "data-name": "Line 108",
    x2: 7.984,
    transform: "translate(14.531 23.291)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1811",
    "data-name": "Group 1811",
    transform: "translate(15737.188 13290.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cloud-protection-1652500",
    transform: "translate(-20850.99 -2995.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8215",
    "data-name": "Path 8215",
    d: "M63.188,78.443a10.99,10.99,0,1,0,0-21.98,11.892,11.892,0,0,0-1.889.159,16.956,16.956,0,0,0-33.546-.1,10.752,10.752,0,0,0-1.263-.074,10.99,10.99,0,1,0,0,21.98",
    transform: "translate(-15.5 -42.1)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIkon);
export default __webpack_public_path__ + "static/media/Cloud-ikon.4a7addc0cebc91c72b6f1b83e79279ae.svg";
export { ForwardRef as ReactComponent };